import { render } from "./NinhBinh.vue?vue&type=template&id=132bc38b&scoped=true"
import script from "./NinhBinh.vue?vue&type=script&scoped=true&lang=js"
export * from "./NinhBinh.vue?vue&type=script&scoped=true&lang=js"

import "./NinhBinh.vue?vue&type=style&index=0&id=132bc38b&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-132bc38b"]])

export default __exports__